export default "__VITE_ASSET__ds6FMbHs__"